'use strict';

var _classCallCheck = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var setImmediate = require('async/setImmediate');

var series = require('async/series');

var detect = require('async/detect');

var waterfall = require('async/waterfall');

require('node-forge/lib/pkcs7');

require('node-forge/lib/pbe');

var forge = require('node-forge/lib/forge');

var util = require('./util');
/**
 * Cryptographic Message Syntax (aka PKCS #7)
 *
 * CMS describes an encapsulation syntax for data protection. It
 * is used to digitally sign, digest, authenticate, or encrypt
 * arbitrary message content.
 *
 * See RFC 5652 for all the details.
 */


var CMS =
/*#__PURE__*/
function () {
  /**
   * Creates a new instance with a keychain
   *
   * @param {Keychain} keychain - the available keys
   */
  function CMS(keychain) {
    _classCallCheck(this, CMS);

    if (!keychain) {
      throw new Error('keychain is required');
    }

    this.keychain = keychain;
  }
  /**
   * Creates some protected data.
   *
   * The output Buffer contains the PKCS #7 message in DER.
   *
   * @param {string} name - The local key name.
   * @param {Buffer} plain - The data to encrypt.
   * @param {function(Error, Buffer)} callback
   * @returns {undefined}
   */


  _createClass(CMS, [{
    key: "encrypt",
    value: function encrypt(name, plain, callback) {
      var self = this;

      var done = function done(err, result) {
        return setImmediate(function () {
          return callback(err, result);
        });
      };

      if (!Buffer.isBuffer(plain)) {
        return done(new Error('Plain data must be a Buffer'));
      }

      series([function (cb) {
        return self.keychain.findKeyByName(name, cb);
      }, function (cb) {
        return self.keychain._getPrivateKey(name, cb);
      }], function (err, results) {
        if (err) return done(err);
        var key = results[0];
        var pem = results[1];

        try {
          var privateKey = forge.pki.decryptRsaPrivateKey(pem, self.keychain._());
          util.certificateForKey(key, privateKey, function (err, certificate) {
            if (err) return callback(err); // create a p7 enveloped message

            var p7 = forge.pkcs7.createEnvelopedData();
            p7.addRecipient(certificate);
            p7.content = forge.util.createBuffer(plain);
            p7.encrypt(); // convert message to DER

            var der = forge.asn1.toDer(p7.toAsn1()).getBytes();
            done(null, Buffer.from(der, 'binary'));
          });
        } catch (err) {
          done(err);
        }
      });
    }
    /**
     * Reads some protected data.
     *
     * The keychain must contain one of the keys used to encrypt the data.  If none of the keys
     * exists, an Error is returned with the property 'missingKeys'.  It is array of key ids.
     *
     * @param {Buffer} cmsData - The CMS encrypted data to decrypt.
     * @param {function(Error, Buffer)} callback
     * @returns {undefined}
     */

  }, {
    key: "decrypt",
    value: function decrypt(cmsData, callback) {
      var done = function done(err, result) {
        return setImmediate(function () {
          return callback(err, result);
        });
      };

      if (!Buffer.isBuffer(cmsData)) {
        return done(new Error('CMS data is required'));
      }

      var self = this;
      var cms;

      try {
        var buf = forge.util.createBuffer(cmsData.toString('binary'));
        var obj = forge.asn1.fromDer(buf);
        cms = forge.pkcs7.messageFromAsn1(obj);
      } catch (err) {
        return done(new Error('Invalid CMS: ' + err.message));
      } // Find a recipient whose key we hold. We only deal with recipient certs
      // issued by ipfs (O=ipfs).


      var recipients = cms.recipients.filter(function (r) {
        return r.issuer.find(function (a) {
          return a.shortName === 'O' && a.value === 'ipfs';
        });
      }).filter(function (r) {
        return r.issuer.find(function (a) {
          return a.shortName === 'CN';
        });
      }).map(function (r) {
        return {
          recipient: r,
          keyId: r.issuer.find(function (a) {
            return a.shortName === 'CN';
          }).value
        };
      });
      detect(recipients, function (r, cb) {
        return self.keychain.findKeyById(r.keyId, function (err, info) {
          return cb(null, !err && info);
        });
      }, function (err, r) {
        if (err) return done(err);

        if (!r) {
          var missingKeys = recipients.map(function (r) {
            return r.keyId;
          });
          err = new Error('Decryption needs one of the key(s): ' + missingKeys.join(', '));
          err.missingKeys = missingKeys;
          return done(err);
        }

        waterfall([function (cb) {
          return self.keychain.findKeyById(r.keyId, cb);
        }, function (key, cb) {
          return self.keychain._getPrivateKey(key.name, cb);
        }], function (err, pem) {
          if (err) return done(err);
          var privateKey = forge.pki.decryptRsaPrivateKey(pem, self.keychain._());
          cms.decrypt(r.recipient, privateKey);
          done(null, Buffer.from(cms.content.getBytes(), 'binary'));
        });
      });
    }
  }]);

  return CMS;
}();

module.exports = CMS;